import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
import { SocketStatusChangeParameters } from '@/ts/HococoInterfaces';

@Module({name: 'Socket', namespaced: true})
export default class Socket extends VuexModule {
    private socketActive: boolean = false;
    private conversationSocketInitialized: boolean = false;
    private ticketSocketInitialized: boolean = false;
    private identitySocketInitialized: boolean = false;
    private tenantLogSocketInitialized: boolean = false;

    @Mutation
    public RESET_SOCKET_STORE_STATE(): void {
        this.socketActive                  = false;
        this.conversationSocketInitialized = false;
        this.ticketSocketInitialized       = false;
        this.identitySocketInitialized     = false;
        this.tenantLogSocketInitialized    = false;
    }

    @Mutation
    public RESET_SOCKET_INITIALIZATIONS(): void {
        this.conversationSocketInitialized = false;
        this.ticketSocketInitialized       = false;
    }

    get isSocketActive(): boolean {
        return this.socketActive;
    }

    get isConversationSocketInitialized(): boolean {
        return this.conversationSocketInitialized;
    }

    get isTicketSocketInitialized(): boolean {
        return this.ticketSocketInitialized;
    }

    get isIdentitySocketInitialized(): boolean {
        return this.identitySocketInitialized;
    }

    get isTenantLogSocketInitialized() {
        return this.tenantLogSocketInitialized;
    }

    @Mutation
    public SET_SOCKET_STATUS(parameters: SocketStatusChangeParameters) {
        this.socketActive = parameters.status;
    }

    @Mutation
    public CONVERSATION_SOCKET_INITIALIZED() {
        this.conversationSocketInitialized = true;
    }

    @Mutation
    public TICKET_SOCKET_INITIALIZED() {
        this.ticketSocketInitialized = true;
    }

    @Mutation
    public IDENTITY_SOCKET_INITIALIZED() {
        this.identitySocketInitialized = true;
    }

    @Mutation
    public SET_TENANT_LOG_SOCKET_INITIALIZED() {
        this.tenantLogSocketInitialized = true;
    }
}
